import { render } from "./p-draggable-tree.vue?vue&type=template&id=6eddb56b"
import script from "./p-draggable-tree.vue?vue&type=script&lang=js"
export * from "./p-draggable-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-draggable-tree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eddb56b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eddb56b', __exports__)) {
    api.reload('6eddb56b', __exports__)
  }
  
  module.hot.accept("./p-draggable-tree.vue?vue&type=template&id=6eddb56b", () => {
    api.rerender('6eddb56b', render)
  })

}


export default __exports__